import React, {useState, useRef, useEffect, useCallback, useMemo} from 'react';
import {View, Dimensions} from 'react-native';
import EStyleSheet from "react-native-extended-stylesheet";

import AppButton from "../../../components/AppButton";
import {basicStyles} from "../../../styles/basic";
import ScreenOverlay from "../../../components/ScreenOverlay";
import ContentSection from "../../../components/ContentSection";
import PhoneInput from "../../../components/PhoneInput";
import {EmailInput} from "../../../components/EmailInput";
import AppTextInput from "../../../components/AppTextInput";
import AppActiveButton from "../../../components/AppActiveButton";
import {useDarkMode} from "../DarkModeContext";

function CreateNewMessageModal({
                                   handleClose,
                                   handleSubmit = (messageType, destination, subject) => destination,
                                   type,
                               }) {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [phoneNumberSmsReady, setPhoneNumberSmsReady] = useState(false);

    const [emailAddress, setEmailAddress] = useState('');
    const [emailValid, setEmailValid] = useState(false);
    const [subject, setSubject] = useState('');

    const phoneInputRef = useRef(null);
    const emailInputRef = useRef(null);

    const [messageType, setMessageType] = useState(type);
    const {isDarkMode, theme} = useDarkMode();
    const screenWidth = useMemo(() => Dimensions.get('window').width, []);

    useEffect(() => {
        if (messageType === 'phone' && phoneInputRef.current) {
            phoneInputRef.current.focus();
        } else if (messageType === 'email' && emailInputRef.current) {
            emailInputRef.current.focus();
        }
    }, [messageType]);

    const submit = useCallback(() => {
        if (messageType === 'phone') {
            handleSubmit(messageType, phoneNumber, null);
        } else if (messageType === 'email') {
            handleSubmit(messageType, emailAddress, subject);
        }
    }, [messageType, phoneNumber, emailAddress, subject, handleSubmit]);

    const resetFields = useCallback(() => {
        setPhoneNumber('');
        setPhoneNumberSmsReady(false);
        setEmailValid(false);
        setEmailAddress('');
    }, [setPhoneNumber, setPhoneNumberSmsReady, setEmailValid, setEmailAddress]);



    const contentBlocks = [];

 
        contentBlocks.push(
            <View key="type-buttons" style={styles.buttonContainer}>
                <AppActiveButton
                    label="Email"
                    action={() => {
                        resetFields();
                        setMessageType('email')
                    }}
                    theme="transBlue"
                    active={messageType === 'email'}
                />

                <AppActiveButton
                    label="Text"
                    action={() => {
                        resetFields();
                        setMessageType('phone')
                    }}
                    theme="transBlue"
                    active={messageType === 'phone'}
                />
            </View>
        );
    

    if (messageType === 'phone') {
        contentBlocks.push(
            <PhoneInput
                key="phone-input"
                ref={phoneInputRef}
                label="What is the phone number?"
                onChangeText={value => setPhoneNumber(value)}
                value={phoneNumber}
                validateSms={true}
                validationCallBack={(validated) => {
                    setPhoneNumberSmsReady(validated);
                }}
                wrapperStyle={[
                    {marginTop: 10},
                    isDarkMode ? {backgroundColor: theme.inputBg, borderColor: theme.inputBorder} : {},
                ]}
                labelStyle={isDarkMode ? {color: theme.textSecondary} : {}}
                inputStyle={isDarkMode ? {color: theme.text} : {}}
                placeholderTextColor={isDarkMode ? theme.placeholderColor : undefined}
                validationTextStyle={isDarkMode ? {color: theme.textSecondary} : {}}
            />
        );
    }

    if (messageType === 'email') {
        contentBlocks.push(
            <AppTextInput
                key="email-subject"
                label={'What is the subject?'}
                value={subject}
                onChangeText={value => setSubject(value)}
                wrapperStyle={[
                    {marginTop: 10},
                    isDarkMode ? {backgroundColor: theme.inputBg, borderColor: theme.inputBorder} : {},
                ]}
                labelStyle={isDarkMode ? {color: theme.textSecondary} : {}}
                inputStyle={isDarkMode ? {color: theme.text} : {}}
                placeholderTextColor={isDarkMode ? theme.placeholderColor : undefined}
            />
        );

        contentBlocks.push(
            <EmailInput
                key="email-address"
                ref={emailInputRef}
                label={'What is the email address?'}
                value={emailAddress}
                onChangeText={value => setEmailAddress(value)}
                validationCallback={(validated) => {
                    setEmailValid(validated);
                }}
                style={{marginTop: 10}}
                labelStyle={isDarkMode ? {color: theme.textSecondary} : {}}
                inputStyle={isDarkMode ? {color: theme.text} : {}}
                wrapperStyle={isDarkMode ? {backgroundColor: theme.inputBg, borderColor: theme.inputBorder} : {}}
                placeholderTextColor={isDarkMode ? theme.placeholderColor : undefined}
            />
        );
    }

    if (messageType) {
        contentBlocks.push(
            <View key="actions" style={[basicStyles.flexRow, basicStyles.justifyContentFlexEnd, {marginTop: 20}]}>
                <AppButton
                    label="Cancel"
                    action={handleClose}
                    style={{marginRight: 10}}
                    theme="transBlue"
                />
                <AppButton
                    label="Confirm"
                    action={() => {
                        submit(phoneNumber);
                    }}
                    style={{marginRight: 10}}
                    disabled={!phoneNumberSmsReady && !emailValid}
                />
            </View>
        );
    }

    return (
        <ScreenOverlay
            style={[
                styles.overlay,
                {left: screenWidth >= 630 ? 80 : 0},
                isDarkMode && {backgroundColor: 'rgba(0, 0, 0, 0.7)'},
            ]}
            onClick={() => {
                handleClose();
            }}
        >
            <ContentSection
                style={[
                    styles.contentWrapper,
                    isDarkMode && {
                        backgroundColor: theme.background,
                        borderColor: theme.border,
                    },
                ]}
                onClick={e => {
                    e.stopPropagation();
                }}
            >
                <View>{contentBlocks}</View>
            </ContentSection>
        </ScreenOverlay>
    );
}

export default CreateNewMessageModal;

const styles = EStyleSheet.create({
    overlay: {
        position: 'fixed',
        width: 'auto',
    },
    contentWrapper: {
        padding: 32,
        width: 400,
        maxWidth: '100%',
        marginBottom: 12,
    },
    buttonContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 12,
        marginTop: 10,
        marginBottom: 10,
    },
});
